


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getTestId } from 'frontend/utils/test-id';
import { Optional } from 'frontend/types';

@Component
export default class SuggestedQueries extends Vue {
  @Prop(Boolean) private mobile!: boolean;
  @Prop(String) private readonly testIdPrefix: Optional<string>;

  private get testId(): string {
    return getTestId(this.testIdPrefix, 'suggested_queries');
  }

  private get suggestedQueries(): string[] {
    return this.mobile
      ? [
          'python',
          'logic',
          'probability',
          'algebra',
          'physics',
          'calculus',
          'computer science',
          'math',
          'quantum',
          'chemistry',
        ]
      : [
          'python',
          'calculus',
          'probability',
          'logic',
          'algebra',
          'chemistry',
          'physics',
          'math',
          'number theory',
          'integration',
          'statistics',
          'quantum',
          'computer science',
          'exponents',
          'limit',
        ];
  }

  private updateSearchQuery(query: string): void {
    this.$emit('update-search-query', query);
  }
}
